export const UI_updatePostPanAckScreenReducer = {
  UI_updatePostPanAckScreen: (state, action) => {
    state.postpanackscreen = action.payload;
  },
};
